// extracted by mini-css-extract-plugin
export var arrows = "_87-6";
export var decrementer = "_87-a";
export var disabled = "_87-4";
export var error = "_87-1";
export var hiddenText = "_87-b";
export var incrementer = "_87-9";
export var input = "_87-8";
export var inputWrapper = "_87-0";
export var leadingIcon = "_87-c";
export var readonly = "_87-3";
export var regular = "_87-7";
export var small = "_87-5";
export var warning = "_87-2";